import { HSLColor } from "../../colors/HSLColor";
import { AttributeValue } from "../../dom-tools/AttributeValue";
import { ElementAttribute } from "../../dom-tools/ElementAttribute";
import { ElementSelector } from "../../dom-tools/ElementSelector";
import { ElementSelectors } from "../../dom-tools/ElementSelectors";
import { LinearGradient } from "../../dom-ui/basics/Gradient";
import { LCG } from "../../random/LCG";
import { RandomEngine } from "../../random/RandomEngine";
import { SetBackgroundAttribute } from "./SetBackgroundAttribute";
import { CSS } from "../../css/CSS";
import { DomID } from "../../dom-tools/DomID";

export class HueGradientBackground
{
  static type = new AttributeValue( SetBackgroundAttribute.value, "hue--gradient" );
  static settings    = new ElementAttribute( "-hue--gradient--settings" );
  static hueOverwrite = new ElementAttribute( "-hue--gradient--hue--overwrite" );

  static getSetting( index:number, settings:number[], alternative:number = 0)
  {
    if ( ! settings || settings.length < index)
    {
      return alternative;
    }

    return settings[ index ];
  }


  static setBackground( e:Element, backgroundElement:Element, random:RandomEngine, parentElement:Element )
  {
    let settings = HueGradientBackground.settings.parseNumbers( parentElement );
    
    
    let hue = random.range( 0, 360 );

    if ( HueGradientBackground.hueOverwrite.in( parentElement ) )
    {
      let overwriteAttribute = new ElementAttribute( HueGradientBackground.hueOverwrite.from( parentElement ), false );  
      let overwriteElement = overwriteAttribute.query( e );

      if ( overwriteElement )
      {
        hue = overwriteAttribute.asNumberFrom( overwriteElement );
      }
    }
    
    


    let warmenHue = this.getSetting( 0, settings, 5 );    
    
    let s0 = this.getSetting( 1, settings, 75 );
    let s1 = this.getSetting( 2, settings, 85 );
    
    let l0 = this.getSetting( 3, settings, 50 );    
    let l1 = this.getSetting( 4, settings, 55 );

    let a0 = this.getSetting( 5, settings, 1 );    
    let a1 = this.getSetting( 6, settings, 1 );

    let colorA = new HSLColor( hue, s0, l0, a0 ).shiftWarmerHue( warmenHue );
    let color  = new HSLColor( hue, ( s0 + s1 ) / 2, ( l0 + l1 ) / 2, ( a0 + a1 ) / 2 );
    let colorB = new HSLColor( hue, s1, l1, a1 ).shiftWarmerHue( - warmenHue );

    // console.log( "CREATING HUE:", hue, ">>", colorA, colorB );

    let lg = LinearGradient.create( [ colorA, color, colorB ] );

    // lg.applyToBackground( backgroundElement as HTMLElement );

    let css = new CSS();
    css.background = lg;

    css.atMedia = "( orientation: landscape )";

    css.appendToElement( backgroundElement );

  }
}